<template>
  <sa-page-layout :showModalLoading="showModalLoading" :pathResource="pathResource" btnRefreshVisible
    @refresh="onClickRefresh">
    <template slot="toolbar">
    </template>

    <template slot="table-filter">
      <b-form style="width: 100%" @submit.prevent="submit">
        <div class="sa-form-section sa-search-box">
          <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="sa-form-btn-filter">
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Presidio</label>
                <div class="sa-page-search-component-wrapper">
                  <b-form-select class="sa-search-input mb-2 mr-sm-2 mb-sm-0" v-model="filtro.idPresidio"
                    @change="onChangePresidio()" :value="null" value-field="codiceStruttura" text-field="denominazione">
                    <template #first>
                      <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                    </template>
                    <template>
                      <b-form-select-option v-for="presidio of presidiOptions" :key="presidio.id"
                        :value="presidio.idPresidio">
                        {{ presidio.denominazionePresidio }} ({{ presidio.denominazioneStruttura
                        }})</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Presidio</label>
                <div class="sa-page-search-component-wrapper">
                  <b-form-select class="sa-search-input mb-2 mr-sm-2 mb-sm-0" v-model="filtro.idAgenda"
                    @change="onChangeAgenda" :value="null" value-field="codiceStruttura" text-field="denominazione">
                    <template #first>
                      <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                    </template>
                    <template>
                      <b-form-select-option v-for="agenda of agendaOptions" :key="agenda.id" :value="agenda.id">
                        {{ agenda.titolo }}
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Riferimento</label>

                <div class="sa-page-search-component-wrapper">
                  <datePicker format="DD/MM/YYYY" value-type="timestamp" @change="onChangeDate"
                    v-model="dataRiferimento" type="date">
                  </datePicker>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3" class="d-flex justify-content-end align-items-center">
              <label for=""></label>

              <b-button size="sm" class="mr-1 ml-1 no-text" variant="outline-primary" @click="onSubmit">
                <i class="fas fa-search"></i>
                Ricerca
              </b-button>
            </b-col>
            <!-- 
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Accettazione Dal</label>
                <div class="sa-page-search-component-wrapper">
                  <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="filtro.dataOraInizio"
                    type="date"></date-picker>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Accettazione Al</label>
                <div class="sa-page-search-component-wrapper">
                  <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="filtro.dataOraFine"
                    type="date"></date-picker>
                </div>
              </div>
            </b-col>
            -->
          </b-row>
        </div>
      </b-form>
    </template>
    <template slot="table-body">
      <AccettazioneRicettaPrestazioniListaComponent ref="cmpAccettazionRicettaPrestazioni" />
    </template>
  </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";

import AccettazioneRicettaPrestazioniListaComponent from "../componets/AccettazioneRicettaPrestazioniListaComponent.vue"
import toast from "../../../../template/layout/utility/sa-toast.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

// import DatePicker from "vue2-datepicker";
//import { jsontest } from "../components/jsontest.js";

export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  // DatePicker,
  components: {

    SaPageLayout,
    AccettazioneRicettaPrestazioniListaComponent,
    DatePicker
  },
  mixins: { UtilityMixin },
  data() {
    return {
      pathResource: "/accettazionessn",
      pathResourcePresidi: "/utentipresidi",
      rows: 0,
      perPage: 20,
      user: {},
      isRicercaComponent: false,
      presidiOptions: [],
      page: 1,
      presidio: null,
      agendaOptions: [],
      dataRiferimento: new Date().getTime(),
      filtro: {
        idPresidio: null,
        idAgenda: null
      },
      listKey: 0,
      showModalLoading: false,
    };
  },
  mounted() {
    this.init();
  },

  methods: {
    init() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        let presidio = JSON.parse(tmpPresidio);
        this.presidio = presidio;
        this.filtro.idPresidio = presidio.idPresidio;
      }
      this.loadUserData();
      this.loadAgende();
      this.$refs.cmpAccettazionRicettaPrestazioni.init(this.filtro, this.dataRiferimento);
    },



    onClickRefresh() {
      this.init();
    },
    onSubmit() {
      this.$refs.cmpAccettazionRicettaPrestazioni.init(this.filtro, this.dataRiferimento);
    },

    onOpenDetailRow() {
      let me = this;
      me.$refs.mdlAccettazioneSsn.show();
    },
    loadUserData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/users/profile";
      axios
        .get(link)
        .then((response) => {
          me.utente = response.data.data;
          me.user = me.utente;
          me.user.nominativoUtente = me.utente.lastname + " " + me.utente.firstname;
          me.user.ruolo = me.utente.profilo;
          me.loadDataUtentiPresidio(me.utente.id);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loadAgende() {
      if (!this.filtro.idPresidio) {
        toast.warning("Selezionare Presidio");
        return;
      }
      let link = process.env.VUE_APP_PATH_API + "/agende";
      axios
        .get(link, { params: this.filtro })
        .then((response) => {
          this.agendaOptions = response.data.data;

        })
        .catch((e) => {
          console.log(e);
        });

    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onBeforeSaved(item) {
      console.log(item);

      //devido se fare redirect su pagina scheda paziente o ricarice la paginaa
    },
    onChangePresidio() {
      this.filtro.idAgenda = null;
      this.loadAgende();
    },
    loadDataUtentiPresidio(id) {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, { idUtente: id }, me.loadDataUtentiPresidiSuccess, me.loadDataUtentiPresidiError);
    },
    loadDataUtentiPresidiSuccess(response) {
      let me = this;
      me.presidiOptions = response.data.data.list;
      if (me.presidiOptions.length == 1) {
        me.filtro.idPresidio = me.presidiOptions[0].idPresidio;

      }

    },
    loadDataUtentiPresidiError(error) {
      console.log(error);
    },

    setFiltroSessionStorage(filtro) {
      let me = this;
      me.filtro.page = me.page;
      me.filtro.forPage = me.perPage;
      sessionStorage.setItem("filtroPageAppuntamenti", JSON.stringify(filtro));
    },
    onChangeAgenda() {
      this.$refs.cmpAccettazionRicettaPrestazioni.init(this.filtro, this.dataRiferimento);
    },
    onChangeDate() {
      this.$refs.cmpAccettazionRicettaPrestazioni.init(this.filtro, this.dataRiferimento);
    }

  },
};
</script>

<style scoped></style>
